export default "__VITE_ASSET__uQvs$rKJ__"